import { useQuery } from 'react-query'
import { DEVICE_OVERALL_URL } from '../requests/urls'
import client from './axios-client'
import { DEVICES_REPORT_KEY } from './cache-keys';


export const useGetDeviceOverallInfo = () => useQuery(DEVICES_REPORT_KEY(), () => client.get(DEVICE_OVERALL_URL))